import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import { useState, useMemo, useCallback } from 'react';

function useSet(initialValue) {
  var initialSet = useMemo(function () {
    return initialValue === undefined ? new Set() : new Set(initialValue);
  }, [initialValue]);

  var _useState = useState(initialSet),
      set = _useState[0],
      setSet = _useState[1];

  var stableActions = useMemo(function () {
    return {
      add: function add(key) {
        return setSet(function (prevSet) {
          return new Set([].concat(Array.from(prevSet), [key]));
        });
      },
      remove: function remove(key) {
        return setSet(function (prevSet) {
          return new Set(Array.from(prevSet).filter(function (i) {
            return i !== key;
          }));
        });
      },
      reset: function reset() {
        return setSet(initialSet);
      }
    };
  }, [setSet]);
  var utils = Object.assign({
    has: useCallback(function (key) {
      return set.has(key);
    }, [set])
  }, stableActions);
  return [set, utils];
}

export default useSet;